import React from "react";
import CountUp from "react-countup";
import "../nailcss/Whyusnail.css";

// Free-to-use nail art photos (Pexels direct hotlink URLs) — no local
// image files, so no "module not found" build errors.
const MainWhy = "https://images.pexels.com/photos/22668317/pexels-photo-22668317.jpeg?auto=compress&cs=tinysrgb&w=1200";

const img1 = "https://images.pexels.com/photos/34835286/pexels-photo-34835286.jpeg?auto=compress&cs=tinysrgb&w=800"; // Nail Extensions
const img2 = "https://images.pexels.com/photos/34835304/pexels-photo-34835304.jpeg?auto=compress&cs=tinysrgb&w=800"; // Nail Art & Design
const img3 = "https://images.pexels.com/photos/7446914/pexels-photo-7446914.jpeg?auto=compress&cs=tinysrgb&w=800";   // Manicure & Pedicure
const img4 = "https://images.pexels.com/photos/34871553/pexels-photo-34871553.jpeg?auto=compress&cs=tinysrgb&w=800"; // Nail Repair & Overlay
const img5 = "https://images.pexels.com/photos/34997574/pexels-photo-34997574.jpeg?auto=compress&cs=tinysrgb&w=800"; // French & Ombre Nails
const img6 = "https://images.pexels.com/photos/7066298/pexels-photo-7066298.jpeg?auto=compress&cs=tinysrgb&w=800";   // Nail Polish & Cuticle Care

const WhyUsNail = () => {

  return (
    <div className="whyusnail-section">

      <div className="whyusnail-container">

        <h2 className="whyusnail-heading">Pick Your Favorite Nail Art &amp; Care Service at Home</h2>

        <div className="whyusnail-subtext">
          Best Quality Nail Products&nbsp;|&nbsp;Trained &amp; Verified Nail Artists&nbsp;|&nbsp;Pocket-Friendly Offers&nbsp;|&nbsp;Delhi NCR, Noida, Faridabad, Greater Noida
        </div>

        <div className="whyusnail-grid">

          <div className="whyusnail-col">

            <div className="whyusnail-item">
              <div className="whyusnail-item-icon">
                <img title="Nail extensions at home" src={img1} alt="Nail Extensions" />
              </div>
              <div className="whyusnail-item-content">
                <div className="whyusnail-item-title">Nail Extensions</div>
                <div className="whyusnail-item-text">
                  Get salon-perfect Gel and Acrylic nail extensions in the shape and length you love, done at your home by our trained nail artists with a fully sanitised kit.
                </div>
              </div>
            </div>

            <div className="whyusnail-item">
              <div className="whyusnail-item-icon">
                <img title="Nail art designs at home" src={img2} alt="Nail Art & Design" />
              </div>
              <div className="whyusnail-item-content">
                <div className="whyusnail-item-title">Nail Art &amp; Design</div>
                <div className="whyusnail-item-text">
                  From minimal to statement designs — glitter, ombre, chrome and hand-painted nail art customised to match your outfit or occasion, all in the comfort of your home.
                </div>
              </div>
            </div>

            <div className="whyusnail-item">
              <div className="whyusnail-item-icon">
                <img title="Manicure and pedicure at home" src={img3} alt="Manicure & Pedicure" />
              </div>
              <div className="whyusnail-item-content">
                <div className="whyusnail-item-title">Manicure &amp; Pedicure</div>
                <div className="whyusnail-item-text">
                  Relax with a classic or spa manicure-pedicure that cleans, shapes and nourishes your hands and feet, leaving your nails healthy and salon-fresh.
                </div>
              </div>
            </div>

          </div>

          <div className="whyusnail-main-image-wrap">
            <div className="whyusnail-main-image-ring">
              <img className="whyusnail-main-image" title="Nail art & extension at home" src={MainWhy} alt="Nail Art & Extension at Home" />
            </div>
          </div>

          <div className="whyusnail-col">

            <div className="whyusnail-item whyusnail-item-reverse">
              <div className="whyusnail-item-icon">
                <img title="Nail repair at home" src={img4} alt="Nail Repair & Overlay" />
              </div>
              <div className="whyusnail-item-content">
                <div className="whyusnail-item-title">Nail Repair &amp; Overlay</div>
                <div className="whyusnail-item-text">
                  Broken, brittle or uneven nails? Our nail artists fix and strengthen them with gel overlays so your hands always look neat and put-together.
                </div>
              </div>
            </div>

            <div className="whyusnail-item whyusnail-item-reverse">
              <div className="whyusnail-item-icon">
                <img title="French and ombre nails at home" src={img5} alt="French & Ombre Nails" />
              </div>
              <div className="whyusnail-item-content">
                <div className="whyusnail-item-title">French &amp; Ombre Nails</div>
                <div className="whyusnail-item-text">
                  Timeless French tips or trending ombre shades — get the classic, elegant nail looks done neatly at home for everyday wear or special occasions.
                </div>
              </div>
            </div>

            <div className="whyusnail-item whyusnail-item-reverse">
              <div className="whyusnail-item-icon">
                <img title="Nail polish and cuticle care at home" src={img6} alt="Nail Polish & Cuticle Care" />
              </div>
              <div className="whyusnail-item-content">
                <div className="whyusnail-item-title">Nail Polish &amp; Cuticle Care</div>
                <div className="whyusnail-item-text">
                  A quick nail polish change or a soothing cuticle care session to keep your nails looking fresh and well-groomed between full appointments.
                </div>
              </div>
            </div>

          </div>

        </div>

      </div>

      <div className="whyusnail-stats">
        <div className="whyusnail-stats-row">

          <div className="whyusnail-stat">
            <div className="whyusnail-stat-number">
              <CountUp end={90} duration={5} enableScrollSpy />%
            </div>
            <div className="whyusnail-stat-text">
              Of women feel more confident with well-groomed, polished nails
            </div>
          </div>

          <div className="whyusnail-stat">
            <div className="whyusnail-stat-number">
              <CountUp end={85} duration={5} enableScrollSpy />%
            </div>
            <div className="whyusnail-stat-text">
              Of women prefer gel nail extensions over regular nail polish
            </div>
          </div>

          <div className="whyusnail-stat">
            <div className="whyusnail-stat-number">
              <CountUp end={95} duration={5} enableScrollSpy />%
            </div>
            <div className="whyusnail-stat-text">
              Of women think neatly done nails complete their overall look
            </div>
          </div>

        </div>

        <div className="whyusnail-cta-wrap" id="testimonial">
          <a href="#services" className="whyusnail-cta-btn">Book Service Now</a>
        </div>
      </div>

    </div>
  );
};

export default WhyUsNail;
